import { create } from 'zustand';
import type { Company } from 'interfaces/company';

type State = {
  selectedGeneralCompany: Company | null;
}

type Actions = {
  setSelectedGeneralCompany: (company: Company | null) => void;
  clearSelectedGeneralCompany: () => void;
}

export const useSelectedGeneralCompanyState = create<State & Actions>((set) => ({
  selectedGeneralCompany: null,
  setSelectedGeneralCompany: (company) => set({
    selectedGeneralCompany: company,
  }),
  clearSelectedGeneralCompany: () => set({
    selectedGeneralCompany: null,
  }),
}));
